import makeStyles from '@material-ui/core/styles/makeStyles'
import {DeleteIconButton, Text} from '../../1elements'
import {validateRecordName, validateRecordURL} from '../../../services/util/editChecks'
import FormTextField from '../../2compounds/FormTextField'
import AddNewChip from '../../2compounds/AddNewChip'


const useStyles = makeStyles({
    root: {

    },
    fieldsRow: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textField: {
        margin: '0 5px',
        width: '100%'
    },
    deleteButton: {
        marginTop: '22px',
        height: '29px',
        width: '29px'
    }
})

const DocumentsImporter = ({disabled, importDocuments, setImportDocuments, className, showError}) => {
    const classes = useStyles()

    const updateTitle = (index, newValue) => {
        const copyImportDocuments = [...importDocuments]
        copyImportDocuments[index].title = newValue
        setImportDocuments(copyImportDocuments)
    }

    const updateURL = (index, newValue) => {
        const copyImportDocuments = [...importDocuments]
        copyImportDocuments[index].url = newValue
        setImportDocuments(copyImportDocuments)
    }

    const addField = () => {
        const copyImportDocuments = [...importDocuments]
        copyImportDocuments.push({title: '', url: ''})
        setImportDocuments(copyImportDocuments)
    }

    const deleteField = (index) => {
        if(importDocuments.length > 1){
            const copyImportDocuments = [...importDocuments]
            copyImportDocuments.splice(index, 1)
            setImportDocuments(copyImportDocuments)
        }else{
            setImportDocuments([
                {title: '', url: ''}
            ])
        }
    }

    return(
        <div className={`${classes.root} ${className}`}>
            <Text type={'fieldLabel'}>Documents</Text>
            {
                importDocuments.map((document, index)=>(
                    <div className={classes.fieldsRow}>
                        <FormTextField className={classes.textField} disabled={disabled} label={'Document Name'}
                                       hint={'Max. 20 characters'} onChange={(newValue)=>updateTitle(index, newValue)}
                                       value={document.title}
                                       validation={document.url&&showError&&validateRecordName(document.title)}/>
                        <FormTextField className={classes.textField} disabled={disabled} label={'Document Link'}
                                       onChange={(newValue)=>updateURL(index, newValue)} value={document.url}
                                       validation={document.title&&showError&&validateRecordURL(document.url)} />
                        <DeleteIconButton className={classes.deleteButton} disabled={disabled} onClick={()=>{deleteField(index)}} />
                    </div>
                ))
            }
            <AddNewChip onClick={addField} disabled={disabled}/>
        </div>
    )
}

export default DocumentsImporter